
import ButtonComponent from "../components/common/basic-step/Button";
import EditComponent from "../components/common/basic-step/Edit";
import HiddenComponent from "../components/common/basic-step/Hidden";
import InputComponent from "../components/common/basic-step/Input";
import SelectComponent from "../components/common/basic-step/Select";
import DispositionComp from "../components/common/basic-step/DispositionComp";
import DispositionInfo from "../components/common/basic-step/DispositionInfo";
import { registerSteps } from "./workflowRegistry";
import CustomSelectComponent from "../components/common/basic-step/CustomSelect";
import ConfirmComponent from "../components/common/basic-step/Confirm";
import Label from "../components/common/basic-step/Label";

export function registerBasicComponents() { 
  registerSteps({
    Input: InputComponent,
    Select: SelectComponent,
    Hidden: HiddenComponent,
    Disposition: DispositionInfo,
    DispositionComp,
    Button: ButtonComponent,
    Edit: EditComponent,
    CustomSelect: CustomSelectComponent,
    Confirm: ConfirmComponent,
    Label
  });
};